import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-artikelkz7-list-view',
  imports: [],
  templateUrl: './artikelkz7.list-view.html',
  styleUrls: ['./artikelkz7.list-view.css'],
})
export class Artikelkz7ListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
